import {createSlice} from "@reduxjs/toolkit";

interface IInitialState {
  countries: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: IInitialState = {
  countries: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
    },
    countryLogoutReset: (state) => initialState,
  },
});

export const {reset, countryLogoutReset} = countrySlice.actions;

export default countrySlice.reducer;
